module.exports = "https://cdn.hellotech.com/client-assets/video_doorbell_desktop_46284349a119c5d908e56ad9ccd6c4b8.webp";